// eslint-disable-next-line @fx-ui/jdy-design/import-path-restricted
import { isObject, isString } from '@libs/shared';
// eslint-disable-next-line @fx-ui/jdy-design/import-path-restricted
import { getBasePathRouter } from '~/utils/nested-url';

/**
 * 通过Proxy为API提供二级路径前缀
 * @param api
 */
export const createAPIProxy = <T extends object>(api: T): T => {
    return new Proxy(api, {
        get(target, propKey: string) {
            const value = Reflect.get(target, propKey);
            if (api.propertyIsEnumerable(propKey)) {
                if (isString(value)) {
                    return getBasePathRouter(value);
                }
                if (isObject(value)) {
                    return createAPIProxy(value);
                }
            }
            return value;
        }
    });
};
